import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';

@JsonObject('model.ProposalFileInfo')
export class ProposalFileInfo extends AbstractModel {

  @JsonProperty(String, 'id')
  id?: string

  @JsonProperty(String, 'name')
  name?: string

  @JsonProperty(String, 'previewUrl')
  previewUrl?: string
}

@JsonObject('model.ProposalsInfo')
export class ProposalsInfo extends AbstractModel {

  @JsonProperty(String, 'newName')
  newName?: string

  @JsonProperty([ProposalFileInfo], 'existingFiles')
  existingFiles?: ProposalFileInfo[]
}

